import {
  KeyboardArrowDown,
  Delete,
  Edit,
  CheckCircle,
  CheckCircleOutline,
} from "@material-ui/icons";
import React from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { connect } from "react-redux";
import {
  getContingenciesOptionsAction,
  addContingenciesOptionsAction,
  deleteContingenciesOptionsAction,
  editContingenciesOptionsAction,
} from "./../../actions/TransactionActions";
import noRecord from "./../../assets/img/no-record.png";
import DeletePrompt from "../Common/DeletePrompt";
import { toastMessage } from "../Common/Common";
import * as message from "./../../config/CommonMessages";
import * as constant from "./../../config/Constants";

class Contingencies extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: props.title || "Contingencies",
      showLoader: true,
      data: [],
      deletePrompt: false,
      contingencyID: "",
      showAddModal: false,
      addName: "",
      setIsParticipant: false,
      showEditPrompt: false,
      editId: "",
    };

    this.deleteContingency = this.deleteContingency.bind(this);
  }

  columns = [
    {
      name: "Name",
      selector: "name",
      sortable: true,
      ignoreRowClick: true,
    },
    {
      name: "Is participant",
      selector: "isParticipant",
      sortable: true,
      ignoreRowClick: true,
    },
    {
      name: "",
      selector: "action",
      right: true,
      ignoreRowClick: true,
      width: "150px",
    },
  ];

  getContingency() {
    this.props
      .getContingenciesOptionsAction()
      .then((res) => {
        this.setState({
          data: res || [],
          showLoader: false,
        });
      })
      .catch((err) => {});
  }
  componentWillMount() {
    this.getContingency();
  }

  deleteContingency(id) {
    this.setState({ showLoader: true, deletePrompt: false });
    this.props.deleteContingenciesOptionsAction(id).then((res) => {
      this.setState({ showLoader: false });
      this.getContingency();
    });
  }

  openDeletePrompt(id) {
    this.setState({
      deletePrompt: true,
      contingencyID: id,
    });
  }

  openEditPrompt(contingency) {
    this.setState({
      showEditPrompt: true,
      editId: contingency._id,
      addName: contingency.name,
      setIsParticipant: contingency.isParticipant,
    });
  }

  openAddModal() {
    this.setState({
      showAddModal: true,
      addName: "",
      setIsParticipant: false,
    });
  }

  addContingency(name, isParticipant) {
    this.props
      .addContingenciesOptionsAction({
        name: name,
        isParticipant: isParticipant,
      })
      .then((res) => {
        this.setState({
          showAddModal: false,
          addName: "",
          setIsParticipant: false,
        });
        this.getContingency();
      });
  }

  editContingency(name, isParticipant, id) {
    this.props
      .editContingenciesOptionsAction(
        {
          name: name,
          isParticipant: isParticipant,
        },
        id
      )
      .then((res) => {
        this.setState({
          showEditPrompt: false,
          addName: "",
          setIsParticipant: false,
        });
        this.getContingency();
      });
  }

  render() {
    let rows = [];

    for (var i = 0, len = this.state.data.length; i < len; i++) {
      let contingency = this.state.data[i];

      let data = {
        name: contingency.name,
        isParticipant: contingency.isParticipant ? (
          <CheckCircle className="check" style={{ color: "green" }} />
        ) : (
          <CheckCircleOutline className="check-out" />
        ),
        action: (
          <div className="action-btns">
            <Button
              variant="transparent"
              onClick={() => {
                this.openEditPrompt(contingency);
              }}
            >
              <Edit />
            </Button>
            <Button
              variant="transparent"
              onClick={() => {
                this.openDeletePrompt(contingency._id);
              }}
            >
              <Delete />
            </Button>
          </div>
        ),
      };

      rows.push(data);
    }

    return (
      <div>
        <Row className="mx-0 page-head-row page-head-row-big align-items-center">
          <Col className="col-auto">
            <h4 className="title-med mt-0 pt-1">{this.state.title}</h4>
          </Col>
          <Col className="col-auto">
            <Form.Group controlId="" className="mb-0 mr-2"></Form.Group>
          </Col>
          <Col align="right">
            <Button
              onClick={() => {
                this.openAddModal();
              }}
              className="btn btn-primary btn-blue btn-head w-140"
            >
              Add
            </Button>
          </Col>
        </Row>
        {this.state.showLoader ? (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <div className="dt-content-area">
            <DataTable
              columns={this.columns}
              data={rows}
              noDataComponent={
                <div className="no-transaction no-record no-datatable">
                  <div className="no-transaction-inner">
                    <img src={noRecord} alt="no record" />
                    <p>No data found</p>
                  </div>
                </div>
              }
              highlightOnHover={true}
              className="rdt-requests"
              sortIcon={<KeyboardArrowDown className="color-grey-1" />}
            />

            {this.state.showLoader === true && (
              <div className="page-loader">
                <div className="page-loader-inner">
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              </div>
            )}

            <DeletePrompt
              deletePrompt={this.state.deletePrompt}
              itemId={this.state.contingencyID}
              cancel={() => {
                this.setState({ deletePrompt: false });
              }}
              deleteConfirm={this.deleteContingency}
            />

            <Modal
              show={this.state.showAddModal}
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
              className="modal-med modal-400"
              backdrop={false}
            >
              <Modal.Header>
                <Modal.Title id="example-custom-modal-styling-title">
                  Add Contingency
                </Modal.Title>
              </Modal.Header>

              <Modal.Body className="pb-0">
                <div className="form-group">
                  <Form.Label>
                    Name<span className="text-danger"> *</span>
                  </Form.Label>
                  <Form.Control
                    name="name"
                    onChange={(e) => {
                      this.setState({ addName: e.target.value });
                    }}
                  ></Form.Control>
                </div>
                <div className="form-group">
                  <Form.Check
                    name="setIsParticipant"
                    className="d-inline mr-2"
                    onChange={(e) => {
                      this.setState({ setIsParticipant: e.target.checked });
                    }}
                  ></Form.Check>
                  <Form.Label>Is participant? </Form.Label>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="primary"
                  className="btn-blue w-140"
                  onClick={() => {
                    if (this.state.addName === "") {
                      toastMessage(
                        constant.ERROR,
                        message.ENTER_CONTINGENCY_NAME
                      );
                    } else {
                      this.addContingency(
                        this.state.addName,
                        this.state.setIsParticipant
                      );
                    }
                  }}
                >
                  Add
                </Button>
                <Button
                  variant="primary"
                  className="btn-blue btn-outlined w-140"
                  onClick={() => {
                    this.setState({ showAddModal: false });
                  }}
                >
                  Cancel
                </Button>
              </Modal.Footer>
            </Modal>

            {/* Edit Data Modal */}
            <Modal
              show={this.state.showEditPrompt}
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
              className="modal-med modal-400"
              backdrop={false}
            >
              <Modal.Header>
                <Modal.Title id="example-custom-modal-styling-title">
                  Edit Contingency
                </Modal.Title>
              </Modal.Header>

              <Modal.Body className="pb-0">
                <div className="form-group">
                  <Form.Label>
                    Name<span className="text-danger"> *</span>
                  </Form.Label>
                  <Form.Control
                    name="name"
                    value={this.state.addName}
                    onChange={(e) => {
                      this.setState({ addName: e.target.value });
                    }}
                  ></Form.Control>
                </div>
                <div className="form-group">
                  <Form.Check
                    name="setIsParticipant"
                    className="d-inline mr-2"
                    checked={this.state.setIsParticipant}
                    onChange={(e) => {
                      this.setState({ setIsParticipant: e.target.checked });
                    }}
                  ></Form.Check>
                  <Form.Label>Is participant?</Form.Label>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="primary"
                  className="btn-blue w-140"
                  onClick={() => {
                    if (this.state.addName === "") {
                      toastMessage(
                        constant.ERROR,
                        message.ENTER_CONTINGENCY_NAME
                      );
                    } else {
                      this.editContingency(
                        this.state.addName,
                        this.state.setIsParticipant,
                        this.state.editId
                      );
                    }
                  }}
                >
                  Update
                </Button>
                <Button
                  variant="primary"
                  className="btn-blue btn-outlined w-140"
                  onClick={() => {
                    this.setState({ showEditPrompt: false });
                  }}
                >
                  Cancel
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    contingencies: state.reducer.contingencies,
  };
};

export default connect(mapStateToProps, {
  getContingenciesOptionsAction,
  addContingenciesOptionsAction,
  deleteContingenciesOptionsAction,
  editContingenciesOptionsAction,
})(Contingencies);
